import PropTypes from 'prop-types';

/**
 * Компонент помогает управлять отступами рекламы,
 * по состояниям инициализировалась/неинициализировалась.
 */
export default function AdWrapperStyle(props) {
  const {
    children,
    top,
    bottom,
    left,
    right,
  } = props;

  const margin = `${top}px ${right}px ${bottom}px ${left}px`;

  return (
    <div className='wrapper'>
      <style jsx>{`
        .wrapper
          :global(.lb-ad-visible)
            margin ${margin}
      `}</style>
      {children}
    </div>
  );
}

AdWrapperStyle.propTypes = {
  top: PropTypes.number,
  bottom: PropTypes.number,
  left: PropTypes.number,
  right: PropTypes.number,
};

AdWrapperStyle.defaultProps = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
};
